import {
  ThermostatInactivityPeriod,
  transformFromApiFormat,
} from '@/reducers/thermostatInactivityPeriods'
import { Thermostat, ThermostatComfortSetting } from '@/types'
import {
  formatInlineList,
  getInactivePeriodSummaryLines,
} from '../inactive-times/utils'
import { InactiveComfortSetting } from '@/reducers/inactiveComfortSettings'

export function getInactivePeriodSummarySubtitleLines(args: {
  thermostat: Thermostat
  inactivityPeriods: ThermostatInactivityPeriod[]
  comfortSettings: ThermostatComfortSetting[]
  inactiveComfortSettings: InactiveComfortSetting[]
}) {
  const {
    thermostat,
    inactivityPeriods,
    comfortSettings,
    inactiveComfortSettings,
  } = args
  let periodSummaryLines: string[] = []
  try {
    periodSummaryLines = getInactivePeriodSummaryLines(
      inactivityPeriods.map(transformFromApiFormat),
    )
  } catch {
    return []
  }
  const selectedScheduleNamesSummary = (() => {
    const selectedIds = new Set<number>()
    for (const item of inactiveComfortSettings) {
      const csId = item?.comfort_setting?.id
      if (typeof csId === 'number') selectedIds.add(csId)
    }
    const names = comfortSettings
      .filter((cs) => selectedIds.has(cs.id))
      .map((cs) => cs.name)
      .filter(Boolean)
    return formatInlineList(names)
  })()
  const inactiveTimesCardSubtitleLines: string[] = (() => {
    if (thermostat?.inactivity_type === 'time_range') {
      return periodSummaryLines.length > 0 ? periodSummaryLines : []
    }
    if (thermostat?.inactivity_type === 'schedule') {
      return selectedScheduleNamesSummary ? [selectedScheduleNamesSummary] : []
    }
    return []
  })()

  return inactiveTimesCardSubtitleLines
}
